module.exports = __webpack_public_path__ + "img/gb_xhs.f8ce49d.svg";